import { render, staticRenderFns } from "./CodePrefCol.vue?vue&type=template&id=e15711d2&scoped=true&"
import script from "./CodePrefCol.vue?vue&type=script&lang=js&"
export * from "./CodePrefCol.vue?vue&type=script&lang=js&"
import style0 from "./CodePrefCol.vue?vue&type=style&index=0&id=e15711d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15711d2",
  null
  
)

export default component.exports